import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ReCaptchaV3Service} from 'ng-recaptcha';
import {RecaptchaV3Utils} from "../../util/recaptcha-utils";
import {
  ColonnadeOnline,
  ColonnadeOnlineService,
} from "../../lib/colonnade-online/colonnade-online.service";
import {ClientDocument} from "../../lib/client-document/client-document.service";
import {ErrorMessageService} from "../../lib/error-message-parser.service";
import {ApiErrorStateMatcher} from "../../shared/material/api-error-state-matcher";
import {EmptyMessage} from "../../lib/util/messages";

@Component({
  selector: 'app-colonnade-online-offer-password-dialog',
  templateUrl: './colonnade-online-offer-password-dialog.component.html',
  styleUrls: ['./colonnade-online-offer-password-dialog.component.scss']
})
export class ColonnadeOnlineOfferPasswordDialogComponent {

  offerToken: string;
  password: string = '';
  submitting: boolean = false;
  errors?: string;
  matcher: ApiErrorStateMatcher;

  constructor(
    public dialogRef: MatDialogRef<ColonnadeOnlineOfferPasswordDialogComponent, ColonnadeOnlineOfferPasswordDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: ColonnadeOnlineOfferPasswordDialogData,
    private recaptchaV3Service: ReCaptchaV3Service,
    private colonnadeOnlineService: ColonnadeOnlineService,
    private errorMessageService: ErrorMessageService
  ) {
    this.offerToken = data.offerToken;
    this.matcher = new ApiErrorStateMatcher(() => !!this.errors);
  }

  public static openDialog(
    dialog: MatDialog,
    data: ColonnadeOnlineOfferPasswordDialogData,
    resultCallback?: (result?: ColonnadeOnlineOfferPasswordDialogResult) => void): MatDialogRef<ColonnadeOnlineOfferPasswordDialogComponent, ColonnadeOnlineOfferPasswordDialogResult> {
    const dialogRef = dialog.open(ColonnadeOnlineOfferPasswordDialogComponent, {
      closeOnNavigation: true,
      data: data,
      width: '320px',
      height: 'auto',
      panelClass: 'custom-dialog-container',
      backdropClass: 'transparent-backdrop',
    });
    dialogRef.afterClosed().subscribe((result?: ColonnadeOnlineOfferPasswordDialogResult) => {
      if (resultCallback) {
        resultCallback(result);
      }
    });
    return dialogRef;
  }

  submit(): void {
    if (this.data.type == 'LOGIN') {
      this.login();
    } else {
      this.accept();
    }
  }

  private login() {
    if (!this.password) {
      return;
    }
    this.errors = undefined;
    this.submitting = true;
    RecaptchaV3Utils.preAuthenticate(
      this.recaptchaV3Service,
      'offerLogin',
      this.colonnadeOnlineService.offerLogin(ColonnadeOnline.DOCUMENT_TYPE, {
        password: this.password,
        token: this.offerToken
      })
    ).subscribe((clientDocument: ClientDocument.ClientDocument) => {
      this.submitting = false;
      this.dialogRef.close({
        clientDocument: clientDocument
      });
    }, (error: Error) => {
      this.submitting = false;
      const localizedError = this.errorMessageService.parseError(error);
      this.errors = localizedError!.globalErrors.join('<br/>');

    });

  }
  private accept() {
    if (!this.password) {
      return;
    }
    this.errors = undefined;
    this.submitting = true;
    RecaptchaV3Utils.preAuthenticate(
      this.recaptchaV3Service,
      'offerAccept',
      this.colonnadeOnlineService.offerAccept(ColonnadeOnline.DOCUMENT_TYPE, {
        password: this.password,
        token: this.offerToken,
        form: this.data.consentForm
      })
    ).subscribe((result: EmptyMessage) => {
      this.submitting = false;
      this.dialogRef.close({});
    }, (error: Error) => {
      this.submitting = false;
      const localizedError = this.errorMessageService.parseError(error);
      this.errors = localizedError!.globalErrors.join('<br/>');
    });
  }

  getTitleKey(): string {
    if (this.data.type === 'LOGIN') {
      return 'COLONNADE_ONLINE_OFFER_PASSWORD_DIALOG_LOGIN_TITLE';
    }
    return 'COLONNADE_ONLINE_OFFER_PASSWORD_DIALOG_ACCEPT_TITLE';
  }
  getDescriptionKey(): string {
    if (this.data.type === 'LOGIN') {
      return 'COLONNADE_ONLINE_OFFER_PASSWORD_DIALOG_LOGIN_DESCRIPTION';
    }
    return 'COLONNADE_ONLINE_OFFER_PASSWORD_DIALOG_ACCEPT_DESCRIPTION';
  }
}

export interface ColonnadeOnlineOfferPasswordDialogData {
  type: 'LOGIN' | 'ACCEPT';
  offerToken: string;
  consentForm?: ColonnadeOnline.OfferConsentForm
}

export class ColonnadeOnlineOfferPasswordDialogResult {
  clientDocument?: ClientDocument.ClientDocument;
}
